module.exports = __webpack_public_path__ + "img/share-btn-black.5154f003.svg";